import DashboardGenComponent from "@/components/DashboardGenComponent.tsx";
import st from "@/styles/Success.module.scss"
import {useTranslation} from "react-i18next";
import {CircularProgress} from "@mui/material";
import CommonClass from "@/utils/common";
import DividerSimple from "@/ui/DividerSimple.tsx";
import Button from "@/ui/Button.tsx";
import DashboardClass from "@/utils/dashboard_class";
import {useNavigate} from "react-router-dom";
import Images from "@/utils/images.ts";
import {useAtom} from "jotai/index";
import {succeded_transaction} from "@/atoms/common.ts";
import {useEffect} from "react";
import useLoans from "@/hooks/loans.ts";
import CrLineTransactionInterface from "@/types_and_interfaces/cr_line_transaction_interface.ts";
import LoanInterface from "@/types_and_interfaces/loan_interface.ts";

const SignTransactionContractOTP = () => {
    const {t} = useTranslation()
    const l = t("currency")
    const dc = DashboardClass
    const navigate = useNavigate();
    const [data, setData] = useAtom(succeded_transaction)
    const loan = useLoans()
    const typed_data = data as CrLineTransactionInterface
    const lines = loan.getLoansByType("Credit Line") || []

    const line_obj = ():LoanInterface | undefined=>{
        let res:LoanInterface | undefined = undefined
        if(Array.isArray(lines) && lines.length) {
            lines.map((x) => {

                let transactions = x.transactions || []
                transactions.forEach((tr) => {
                    if(tr.urn_tr === typed_data.urn_tr) res = x
                })

            })
        }

        return res
    }

    useEffect(() => {
        
        let timeout = setTimeout(() => {
            
            if(!data) {
                navigate(dc.dashboard_routes.CreditLine)
                
            } else {
                loan.updateUserLoans()
            }
            
            clearTimeout(timeout)
            
        }, 1000)
        
    }, []);
    
    
    return typeof data === "object" ? (
        <DashboardGenComponent
            header_type={"primary"}
            heading={<></>}
            responsive1
            column_center={
                <div className={st.column_center}>
                    <div className={st.heading}>
                        <strong className={st.success_text}>
                            {t("success")}!
                        </strong>
                        
                        <p>
                            {t("sign_success_confirm")}
                        </p>
                    </div>
                    
                    <div className={st.content}>
                        {typeof data === "object" ? (
                            <>
                                <strong>
                                    + {data?.amount && CommonClass.formatMoneyAmount(Number(data.amount))} {l}
                                </strong>
                                
                                <DividerSimple />
                                
                                <div className={st.columns}>
                                    
                                    <div className={st.col}>
                                        
                                        <span>
                                            {t("amount")}
                                        </span>
                                        
                                        <span>
                                            {/*//////////////////////*/}
                                            {data?.amount} {l}
                                        </span>
                                    
                                    </div>
                                    
                                    {/*<div className={st.col}>*/}
                                    {/*    <span>*/}
                                    {/*        {t("period")}*/}
                                    {/*    </span>*/}
                                    {/*    */}
                                    {/*    <span>*/}
                                    {/*        {data?.nr_of_installments && data.nr_of_installments} {t("months")}*/}
                                    {/*    </span>*/}
                                    {/*</div>*/}
                                </div>
                            
                            </>
                        ) : (
                            <CircularProgress
                                sx={{
                                    display: "block",
                                    color: "#000",
                                }}
                            />
                        )}
                    
                    
                    </div>
                    
                    <div className={st.controllers}>
                        
                        <Button
                            light
                            onClick={() => {
                                navigate(dc.dashboard_routes.CreditLine + "/" +line_obj()?.urn)
                                setData(undefined)
                            }}
                        >
                            {t("see_cr_line_details")}
                        </Button>
                        
                        <Button
                            onClick={() => {
                                navigate(dc.dashboard_routes.Home)
                                setData(undefined)
                                
                            }}
                            light
                            outlined
                            className={st.outlined_btn}
                        >
                            {t("dashboard_home")}
                        </Button>
                        
                    </div>
                </div>
            }
            
            full_bg
            corner_image={
                <img
                    className={st.bg_image}
                    src={Images.logos.Success}
                    alt={"success"}
                    width={740}
                    height={740}
                />
            }
        />
    ) : null
}

export default SignTransactionContractOTP